import { getDoc } from 'firebase/firestore';
import { docRef } from '../firebase/client';
import type { Org, OrgSlugIndex } from '../firebase/types';

/**
 * Fetches an organization by its slug.
 * 
 * @param slug - The organization slug
 * @returns The organization document, or null if not found
 */
export async function getOrgForSlug(slug: string): Promise<Org | null> {
  try {
    // Look up the slug index document
    const slugIndexRef = docRef<OrgSlugIndex>('orgSlugs', slug);
    const slugIndexDoc = await getDoc(slugIndexRef);
    
    // If slug index doesn't exist, return null
    if (!slugIndexDoc.exists()) {
      return null;
    }
    
    const slugIndex = slugIndexDoc.data();
    const orgId = slugIndex.orgId;
    
    // If orgId is missing, return null
    if (!orgId) {
      return null;
    }
    
    // Fetch the organization document
    const orgRef = docRef<Org>('orgs', orgId);
    const orgDoc = await getDoc(orgRef);
    
    // If org document doesn't exist, return null
    if (!orgDoc.exists()) {
      return null;
    }
    
    // Return the organization data with its ID
    return {
      ...orgDoc.data(),
      id: orgDoc.id,
    };
  } catch (error) {
    console.error('Error fetching org for slug:', error);
    return null;
  }
}
